import { FormInputText } from '../../formInputsV2/FormInputText';
import { greeniaPrivacyPolicy } from '../../../services/axios-client/axeCommons';
import InputPrivacy from '../../componentsV2/inputs/InputPrivacy';
import { FormLayout } from '../../formInputsV2/FormLayout.styles';
import { SurfaceCardHeading } from '../../formInputsV2/Card.styles';

function RcMotoStepFour({
  answers, register, errors, isValid, dataPrivacy, privacyItemChangeHandler,
  onOpenPrivacyPolicy = greeniaPrivacyPolicy,
  showPrivacyErrors = false,
}) {
  return (
    <>
      <FormLayout id="calcolare">
        <FormInputText
          registration={register('email')}
          error={errors.email?.message}
          valid={isValid('email')}
          label="E-mail"
          placeholder="nome@esempio.it"
        />
        <FormInputText
          registration={register('phone')}
          error={errors.phone?.message}
          valid={isValid('phone')}
          label="Telefono"
          placeholder="Es. 3401234567"
          paragraph="Numeri di rete fissa non accettati dalle aziende"
        />
        <div className="terms">
          <SurfaceCardHeading>Informativa Privacy e IVASS</SurfaceCardHeading>

          <div className="text-decoration-underline mt-1 mb-2">
            <a onClick={() => onOpenPrivacyPolicy()} style={{ cursor: 'pointer' }}>
              <small>Greenia Privacy Policy</small>
            </a>
          </div>
          {dataPrivacy.map((item, i) => (
            <InputPrivacy
              required={item.required}
              label={item.content}
              name={item.type}
              id={item.type}
              key={i}
              checked={answers.privacies.includes(item.id)}
              hasError={showPrivacyErrors && item.required === 1 && !answers.privacies.includes(item.id)}
              onChange={(value) => privacyItemChangeHandler(value, item)}
            />
          ))}
        </div>
      </FormLayout>

    </>
  );
}

export default RcMotoStepFour;
